<template>
  <a class="img-container photo" :href="image.Url" :id="image.Id">
      <a class="content">
          <img :src="image.Url">
      </a>
    
  </a>
</template>
<script>
export default {
    name:"Photo",
    props: ['image'],
}
</script>
<style lang="scss">
   @import 'src/assets/sass/shared.scss';

    
.photo {
    width: 18% !important;
    margin: 5px;
    overflow: hidden;
    position: relative;
    @include aspect-ratio(4,3);
    @include float-left($dir);
    display: inline-block;
    @include prefixer(box-shadow,1px 1px 3px rgba(0, 0, 0, 0.3),("moz","ms","webkit","o"));
    @media (max-width:990px) {
        width: 25% !important;
    }
    @media (max-width:580px) {
        width: 47% !important;
    }

    @media(max-width:390px) {
        width: 100% !important;
    }
    .content{
            border:1px solid white;
            padding:5px;

    }
    img {
        width: 100%;
        height: 100%;
    }

    &:hover {
        .caption {
            bottom: 14%;
        }
    }

    .caption {
        background-color: rgba($main-color,0.7);
        padding: 30px;
        position: absolute;
        border: 2px solid #fff;
        left: 7%;
        bottom: -100%;
        text-align: center;
        @include prefixer(transition,all 0.4s ease,("moz","ms","webkit","o"));

        h4 {
            font-size: 1.2em;
            color: #fff;
            font-family: 'changa';
            font-weight: 600;
        }
    }
}

   
</style>



// WEBPACK FOOTER //
// src/components/products/photo.vue